var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpUsercontrol",
    {
      attrs: {
        loading: _vm.loading,
        reloading: _vm.reloading,
        loaded: _vm.loaded,
        error: _vm.error
      },
      on: {
        reload: function($event) {
          return _vm.evh_7315092382398562_reload($event, {})
        }
      }
    },
    [
      _vm.loaded
        ? _c(
            "DIV",
            [
              _c(
                "ItpFormGroup",
                {
                  attrs: {
                    name: "contract_service",
                    label: _vm._f("pgettext")(
                      "Contract service",
                      "BillingListItem"
                    ),
                    labelColsMd: "3",
                    contentColsMd: "9",
                    labelAlign: _vm.labelAlign
                  }
                },
                [
                  _c("UcContractServiceSelector", {
                    attrs: {
                      item: _vm.item,
                      path: "contract_service",
                      readonly: _vm.isReadonly,
                      clearable: ""
                    },
                    on: {
                      optionSelected: function($event) {
                        return _vm.evh_6466705138206980_optionSelected(
                          $event,
                          {}
                        )
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "ItpFormGroup",
                {
                  attrs: {
                    name: "contract",
                    label: _vm._f("pgettext")("Contract", "BillingListItem"),
                    labelColsMd: "3",
                    contentColsMd: "8",
                    labelAlign: _vm.labelAlign
                  }
                },
                [
                  _c("UcContractSelector", {
                    attrs: {
                      name: "contract",
                      item: _vm.item,
                      path: "contract",
                      readonly: _vm.isReadonly,
                      clearable: ""
                    },
                    on: {
                      optionSelected: function($event) {
                        return _vm.evh_3943151158818434_optionSelected(
                          $event,
                          {}
                        )
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "ItpFormGroup",
                {
                  attrs: {
                    name: "description",
                    label: _vm._f("pgettext")("Description", "BillingListItem"),
                    labelColsMd: "3",
                    contentColsMd: "9",
                    labelAlign: _vm.labelAlign,
                    required: ""
                  }
                },
                [
                  _c("ItpFormInput", {
                    attrs: {
                      name: "description",
                      readonly: _vm.isReadonly,
                      required: ""
                    },
                    model: {
                      value: _vm.item.description,
                      callback: function($$v) {
                        _vm.$set(_vm.item, "description", $$v)
                      },
                      expression: "item.description"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "ItpFormGroup",
                {
                  attrs: {
                    name: "notes",
                    label: _vm._f("pgettext")("Note", "BillingListItem"),
                    labelColsMd: "3",
                    contentColsMd: "9",
                    labelAlign: _vm.labelAlign
                  }
                },
                [
                  _c("ItpFormTextarea", {
                    attrs: { name: "notes", readonly: _vm.isReadonly },
                    model: {
                      value: _vm.item.notes,
                      callback: function($$v) {
                        _vm.$set(_vm.item, "notes", $$v)
                      },
                      expression: "item.notes"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "ItpFormGroup",
                {
                  attrs: {
                    labelColsMd: "3",
                    contentColsMd: "2",
                    name: "invoice_date",
                    label: _vm._f("pgettext")(
                      "Billing due date",
                      "BillingListItem"
                    ),
                    labelAlign: _vm.labelAlign,
                    required: ""
                  }
                },
                [
                  _c("ItpFormDatetime", {
                    attrs: {
                      name: "invoice_date",
                      readonly: _vm.isReadonly,
                      required: ""
                    },
                    model: {
                      value: _vm.item.invoice_date,
                      callback: function($$v) {
                        _vm.$set(_vm.item, "invoice_date", $$v)
                      },
                      expression: "item.invoice_date"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "ItpFormGroup",
                {
                  attrs: {
                    name: "company",
                    label: _vm._f("pgettext")(
                      "Billing company",
                      "BillingListItem"
                    ),
                    labelColsMd: "3",
                    contentColsMd: "8",
                    labelAlign: _vm.labelAlign,
                    required: ""
                  }
                },
                [
                  _c("UcCompanySelector", {
                    attrs: {
                      name: "company",
                      item: _vm.item,
                      path: "company",
                      parameters: _vm.b_6330885590307111_parameters,
                      required: "",
                      readonly: _vm.isReadonly
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "ItpFormGroup",
                {
                  attrs: {
                    name: "client",
                    label: _vm._f("pgettext")("Client", "BillingListItem"),
                    labelColsMd: "3",
                    contentColsMd: "8",
                    labelAlign: _vm.labelAlign,
                    required: ""
                  }
                },
                [
                  _c("UcCompanySelector", {
                    attrs: {
                      name: "partner",
                      item: _vm.item,
                      path: "partner",
                      required: "",
                      readonly: _vm.isReadonly
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "ItpFormGroup",
                {
                  attrs: {
                    labelColsMd: "3",
                    contentColsMd: "2",
                    name: "due_date",
                    label: _vm._f("pgettext")(
                      "Payment due date",
                      "BillingListItem"
                    ),
                    labelAlign: _vm.labelAlign,
                    required: ""
                  }
                },
                [
                  _c("ItpFormDatetime", {
                    attrs: {
                      name: "due_date",
                      required: "",
                      readonly: _vm.isReadonly
                    },
                    model: {
                      value: _vm.item.due_date,
                      callback: function($$v) {
                        _vm.$set(_vm.item, "due_date", $$v)
                      },
                      expression: "item.due_date"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.item.period
                ? _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "period",
                        label: _vm._f("pgettext")(
                          "Billing period",
                          "BillingListItem"
                        ),
                        labelColsMd: "3",
                        contentColsMd: "8",
                        labelAlign: _vm.labelAlign,
                        contentClass: "form-row"
                      }
                    },
                    [
                      _c(
                        "DIV",
                        { staticClass: "col-3" },
                        [
                          _c("ItpFormDatetime", {
                            attrs: {
                              name: "billing_period_start",
                              readonly: _vm.isReadonly,
                              placeholder: _vm._f("pgettext")(
                                "From",
                                "BillingPeriod"
                              )
                            },
                            model: {
                              value: _vm.item.period.start,
                              callback: function($$v) {
                                _vm.$set(_vm.item.period, "start", $$v)
                              },
                              expression: "item.period.start"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "DIV",
                        { staticClass: "col-3" },
                        [
                          _c("ItpFormDatetime", {
                            attrs: {
                              name: "billing_period_end",
                              placeholder: _vm._f("pgettext")(
                                "To",
                                "BillingPeriod"
                              ),
                              readonly: _vm.isReadonly
                            },
                            model: {
                              value: _vm.item.period.end,
                              callback: function($$v) {
                                _vm.$set(_vm.item.period, "end", $$v)
                              },
                              expression: "item.period.end"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c(
                "ItpFormGroup",
                {
                  attrs: {
                    name: "base_price",
                    label: _vm._f("pgettext")("Base price", "BillingListItem"),
                    labelColsMd: "3",
                    contentColsMd: "8",
                    labelAlign: _vm.labelAlign
                  }
                },
                [
                  _c("MonetaryAmountFieldset", {
                    staticClass: "form-row",
                    attrs: {
                      name: "base_price",
                      item: _vm.item,
                      path: "base_price",
                      readonly: _vm.isReadonly
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "ItpFormGroup",
                {
                  attrs: {
                    name: "currency",
                    label: _vm._f("pgettext")(
                      "Exchange rate",
                      "BillingListItem"
                    ),
                    labelColsMd: "3",
                    contentColsMd: "8",
                    labelAlign: _vm.labelAlign,
                    contentClass: "form-row"
                  }
                },
                [
                  _c(
                    "DIV",
                    { staticClass: "col-3" },
                    [
                      _c("ItpFormInput", {
                        attrs: {
                          mask: "number",
                          unmask: "typed",
                          scale: "2",
                          name: "exchange_rate",
                          readonly: _vm.isReadonly,
                          placeholder: _vm._f("pgettext")("Rate", "Invoice")
                        },
                        on: {
                          blur: function($event) {
                            return _vm.evh_4795561206098500_blur($event, {})
                          }
                        },
                        model: {
                          value: _vm.exchange_rate.value,
                          callback: function($$v) {
                            _vm.$set(_vm.exchange_rate, "value", $$v)
                          },
                          expression: "exchange_rate.value"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "DIV",
                    { staticClass: "col-4" },
                    [
                      _c("ItpFormDatetime", {
                        attrs: {
                          name: "exchange_rate_date",
                          readonly: _vm.isReadonly,
                          placeholder: _vm._f("pgettext")("Date", "Invoice")
                        },
                        on: {
                          blur: function($event) {
                            return _vm.evh_6748526895113679_blur($event, {})
                          }
                        },
                        model: {
                          value: _vm.exchange_rate.date,
                          callback: function($$v) {
                            _vm.$set(_vm.exchange_rate, "date", $$v)
                          },
                          expression: "exchange_rate.date"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "DIV",
                    { staticClass: "col-5" },
                    [
                      _c("ItpFormSelect", {
                        attrs: {
                          name: "exchange_rate_source",
                          options: _vm.exchangeRateSources,
                          readonly: _vm.isReadonly,
                          placeholder: _vm._f("pgettext")(
                            "Source",
                            "ExchangeRateFieldset"
                          ),
                          valueField: "value",
                          textField: "name",
                          "null-option": ""
                        },
                        on: {
                          blur: function($event) {
                            return _vm.evh_6986642096364131_blur($event, {})
                          }
                        },
                        model: {
                          value: _vm.exchange_rate.source,
                          callback: function($$v) {
                            _vm.$set(_vm.exchange_rate, "source", $$v)
                          },
                          expression: "exchange_rate.source"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "ItpFormGroup",
                {
                  attrs: {
                    labelColsMd: "3",
                    contentColsMd: "8",
                    name: "quantity",
                    label: _vm._f("pgettext")("Quantity", "BillingListItem"),
                    labelAlign: _vm.labelAlign,
                    required: "",
                    contentClass: "form-row"
                  }
                },
                [
                  _c(
                    "DIV",
                    { staticClass: "col-4" },
                    [
                      _c("ItpFormInput", {
                        attrs: {
                          mask: "number",
                          unmask: "typed",
                          scale: _vm.invoiceLineCalculator.digits.quantity,
                          name: "quantity",
                          required: "",
                          readonly: _vm.isReadonly
                        },
                        on: {
                          blur: function($event) {
                            return _vm.evh_1175399472650195_blur($event, {})
                          }
                        },
                        model: {
                          value: _vm.item.quantity,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "quantity", $$v)
                          },
                          expression: "item.quantity"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "DIV",
                    { staticClass: "col-3" },
                    [
                      _c("ItpFormInput", {
                        attrs: {
                          name: "unit",
                          required: "",
                          readonly: _vm.isReadonly
                        },
                        model: {
                          value: _vm.item.unit,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "unit", $$v)
                          },
                          expression: "item.unit"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "ItpFormGroup",
                {
                  attrs: {
                    labelColsMd: "3",
                    contentColsMd: "8",
                    name: "price",
                    label: _vm._f("pgettext")("Price", "BillingListItem"),
                    labelAlign: _vm.labelAlign,
                    required: "",
                    contentClass: "form-row"
                  }
                },
                [
                  _c(
                    "DIV",
                    { staticClass: "col-4" },
                    [
                      _c("ItpFormInput", {
                        attrs: {
                          name: "price",
                          mask: "number",
                          unmask: "typed",
                          scale: _vm.invoiceLineCalculator.digits.unitPrice,
                          required: "",
                          readonly: _vm.isReadonly
                        },
                        on: {
                          blur: function($event) {
                            return _vm.evh_5418559842130999_blur($event, {})
                          }
                        },
                        model: {
                          value: _vm.item.price,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "price", $$v)
                          },
                          expression: "item.price"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "DIV",
                    { staticClass: "col-3" },
                    [
                      _c("CurrencySelector", {
                        attrs: {
                          name: "currency",
                          item: _vm.item,
                          path: "currency",
                          readonly: _vm.isReadonly
                        },
                        on: {
                          input: function($event) {
                            return _vm.evh_8171208909653862_input($event, {})
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "ItpFormGroup",
                {
                  attrs: {
                    labelColsMd: "3",
                    contentColsMd: "2",
                    name: "discount",
                    label: _vm._f("pgettext")("Discount", "BillingListItem"),
                    labelAlign: _vm.labelAlign,
                    required: "",
                    contentClass: "input-group"
                  }
                },
                [
                  _c("ItpFormInput", {
                    attrs: {
                      name: "discount",
                      type: "number",
                      min: "0",
                      max: "100",
                      required: "",
                      readonly: _vm.isReadonly
                    },
                    on: {
                      blur: function($event) {
                        return _vm.evh_7668065865922821_blur($event, {})
                      }
                    },
                    model: {
                      value: _vm.item.discount,
                      callback: function($$v) {
                        _vm.$set(_vm.item, "discount", $$v)
                      },
                      expression: "item.discount"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group-append" }, [
                    _c("span", { staticClass: "input-group-text" }, [
                      _vm._v("\n          %\n        ")
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "ItpFormGroup",
                {
                  attrs: {
                    labelColsMd: "3",
                    contentColsMd: "2",
                    name: "net_amount",
                    label: _vm._f("pgettext")("Net", "BillingListItem"),
                    labelAlign: _vm.labelAlign,
                    required: ""
                  }
                },
                [
                  _c("ItpFormInput", {
                    attrs: {
                      name: "net_amount",
                      mask: "number",
                      unmask: "typed",
                      scale: _vm.invoiceLineCalculator.digits.amounts,
                      required: "",
                      readonly: _vm.isReadonly
                    },
                    on: {
                      blur: function($event) {
                        return _vm.evh_6529453708504681_blur($event, {})
                      }
                    },
                    model: {
                      value: _vm.item.net_amount,
                      callback: function($$v) {
                        _vm.$set(_vm.item, "net_amount", $$v)
                      },
                      expression: "item.net_amount"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "ItpFormGroup",
                {
                  attrs: {
                    labelColsMd: "3",
                    contentColsMd: "2",
                    name: "tax_code",
                    label: _vm._f("pgettext")("VAT code", "BillingListItem"),
                    labelAlign: _vm.labelAlign,
                    required: ""
                  }
                },
                [
                  _c("TaxCodeSelector", {
                    attrs: {
                      name: "tax_code",
                      item: _vm.item,
                      path: "tax_code",
                      readonly: _vm.isReadonly
                    },
                    on: {
                      blur: function($event) {
                        return _vm.evh_2837120413286864_blur($event, {})
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "ItpFormGroup",
                {
                  attrs: {
                    labelColsMd: "3",
                    contentColsMd: "2",
                    name: "amount",
                    mask: "number",
                    unmask: "typed",
                    scale: _vm.invoiceLineCalculator.digits.amounts,
                    label: _vm._f("pgettext")("Amount", "BillingListItem"),
                    labelAlign: _vm.labelAlign,
                    required: ""
                  }
                },
                [
                  _c("ItpFormInput", {
                    attrs: {
                      name: "amount",
                      mask: "number",
                      unmask: "typed",
                      required: "",
                      readonly: _vm.isReadonly
                    },
                    on: {
                      blur: function($event) {
                        return _vm.evh_1200777560175496_blur($event, {})
                      }
                    },
                    model: {
                      value: _vm.item.amount,
                      callback: function($$v) {
                        _vm.$set(_vm.item, "amount", $$v)
                      },
                      expression: "item.amount"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }